import * as React from 'react'
import { useFormikContext } from 'formik'
import { SalesTeam } from '@user/store/salesTeam/typings'
import type {
  ISalesFunnel,
  ISalesFunnelStage,
} from '@user/store/salesFunnel/typings'
import { ENTITY_TYPES } from '@sales-center/common'
import Grid from '@mui/material/Grid'
import { FormSection } from '@sales-center/components'
import { LeadAssignmentRuleFormModel } from '../typings'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { SalesFunnelSelect } from './SelectElements/SalesFunnelSelect'
import { SalesFunnelStageSelect } from './SelectElements/SalesFunnelStageSelect'
import { SalesTeamMultiSelect } from './SelectElements/SalesTeamMultiSelect/SalesTeamMultiSelect'
import { OwnerSelect } from './SelectElements/OwnerSelect/OwnerSelect'

interface Props {
  salesTeams: SalesTeam[]
  salesFunnels: ISalesFunnel[]
  salesFunnelStages: ISalesFunnelStage[]
  spacing?: number
  onChangeSalesTeam: (value: SalesTeam[] | null) => void
  onChangeSalesFunnel: (value: ISalesFunnel) => void
}

export function SalesOwnership(props: Props) {
  const {
    salesTeams,
    salesFunnels,
    salesFunnelStages,
    spacing = 2,
    onChangeSalesTeam,
    onChangeSalesFunnel,
  } = props

  const {
    values: { salesTeamIds, salesFunnelId },
  } = useFormikContext<LeadAssignmentRuleFormModel>()

  return (
    <FormSection label="Sales Ownership" spacing={spacing} maxWidth="626px">
      <Grid item xs={12}>
        <Box>
          <Typography variant="body2" display="block">
            Select how you would like to assign records if the condition(s)
            above are met.
          </Typography>
          <Typography variant="body2" display="inline">
            Assignment rules will override Sales Team Defaults.
          </Typography>
        </Box>
      </Grid>
      {/* sales team */}
      <Grid item xs={12}>
        <SalesTeamMultiSelect
          name="salesTeamIds"
          label="Sales Team"
          optionList={salesTeams}
          disabled={false}
          required
          onChange={onChangeSalesTeam}
        />
      </Grid>
      {/* owner */}
      <Grid item xs={12}>
        <OwnerSelect
          disabled={salesTeamIds.length === 0}
          salesTeamIds={salesTeamIds}
          entityType={ENTITY_TYPES.Lead}
          name="ownerIds"
          label="Owner"
          required={false}
        />
      </Grid>

      {/* sales funnel */}
      <Grid item xs={12}>
        <SalesFunnelSelect
          name="salesFunnelId"
          label="Sales Funnel"
          salesFunnels={salesFunnels}
          onChange={onChangeSalesFunnel}
          disabled={false}
          required={false}
        />
      </Grid>
      {/* lead status */}

      {/* lead status */}
      <Grid item xs={12}>
        <SalesFunnelStageSelect
          name="leadStatusId"
          label="Lead Status"
          disabled={!salesFunnelId}
          required={false}
          salesFunnelStages={salesFunnelStages}
        />
      </Grid>
    </FormSection>
  )
}
